import React from "react";
import "../Terms&Conditions/TermsAndConditions.css";

export const PrivacyPolicy = () => {
  return (
    <div className="container">
      <div className="termsHeader mt-3">
        <h2>Privacy Policy</h2>
        <p>
          <b> Effective Date: 1-Oct-2025 </b> At Listen Aura India Private
          Limited, we value your privacy. This Privacy Policy explains how we
          collect, use, and protect your information.
        </p>
      </div>
      <div className="termsContainer">
        <div className="terms-list-content">
          <div className="list-header"> Information We Collect </div>
          <div className="terms-content">
            <p>Personal: Name, email, phone number.</p>

            <p>Demographic (optional): Age, gender, language preference. </p>
            <p>
              Sensitive: Any emotional/personal information voluntarily shared.{" "}
            </p>
            <p>Technical: Session history, communication logs. </p>
          </div>
        </div>

        <div className="terms-list-content">
          <div className="list-header">Use of Information </div>
          <div className="terms-content">
            <p>
              <b>We use your information to: </b>
            </p>
            <p>Provide empathetic listening support. </p>
            <p>Match you with suitable listeners. </p>
            <p>Schedule and conduct sessions. </p>
            <p>Send updates and respond to queries. </p>

            <p>We never sell or rent personal data.</p>
          </div>
        </div>

        <div className="terms-list-content">
          <div className="list-header">Confidentiality</div>
          <div className="terms-content">
            <p>Sessions are 100% confidential.</p>

            <p>Exceptions: imminent risk of harm, or legal obligations.</p>
          </div>
        </div>

        <div className="terms-list-content">
          <div className="list-header">Data Protection</div>
          <div className="terms-content">
            <p>We use industry-standard security to protect your data.</p>
            <p>Only authorized staff can access records. </p>
          </div>
        </div>

        <div className="terms-list-content">
          <div className="list-header">Communication Platforms</div>
          <div className="terms-content">
            <p>
              We may connect via WhatsApp, phone, video, or in person—always
              with respect for privacy.{" "}
            </p>
          </div>
        </div>

        <div className="terms-list-content">
          <div className="list-header">Your Rights</div>
          <div className="terms-content">
            <p>
              You may request to access, correct, or delete your data at any
              time by contacting us.
            </p>
          </div>
        </div>

        <div className="terms-list-content">
          <div className="list-header">Updates</div>
          <div className="terms-content">
            <p>
              We may update this policy. Continued use of services implies
              acceptance of changes.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
